import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, lastValueFrom } from "rxjs";
import { environment } from "src/environments/environment";

const ANALYTICS_API = environment.API_ENDPOINT + "/eap";

@Injectable({
  providedIn: "root",
})
export class SupplierAnalyticsService {
  constructor(private http: HttpClient) {}

  async getSupplierComplainsFehlerarten(): Promise<any> {
    return await lastValueFrom(
      this.http.get(ANALYTICS_API + "/supplier/analytics/complains/types")
    );
  }

  async getSupplierAnalyics(): Promise<any> {
    return await lastValueFrom(
      this.http.get(ANALYTICS_API + "/supplier/analytics")
    );
  }
}
